module.exports = __webpack_public_path__ + "static/img/DIYStep3.38cd43f2.jpg";